<template>
  <div class="h-28 w-full white-rounded-box px-7 mb-7">
    <div class="flex items-center mt-9">
      <div class="mr-7 flex-1">
        <input
          type="search"
          @click="handleCreatePost"
          name="post"
          placeholder="Create a Ping"
          class="
            block
            w-full
            bg-white
            border-custom-grey shadow-custom-grey
            rounded-md
            py-2
            pr-3
            text-hint text-black
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleCreatePost() {
      this.$emit("openCreatePost");
    },
  },
};
</script>